module.exports = __webpack_public_path__ + "img/slphouse_main14.01830295.png";